module.exports = __webpack_public_path__ + "img/glass-full.a6a2b65d.svg";